import api from '../services/api';
import { request_error } from './request_error';

import {
  GET_USER_PREMIUM_STATUS_COMPLETE,
  GET_STRIPE_DETAILS_COMPLETE,
  GET_STRIPE_PLANS_COMPLETE
} from './types';


export const getUserPremiumStatus = () => async dispatch => {
  const USER_PREMIUM_STATUS_ENDPOINT = `user/premium/status`;

  try {
    let { data } = await api.get(`${USER_PREMIUM_STATUS_ENDPOINT}`);

    dispatch({ type: GET_USER_PREMIUM_STATUS_COMPLETE, payload: data });
    return data;
  } catch (e) {
    request_error(e);
  }
}

export const getStripeDetails = () => async dispatch => {
  const STRIPE_DETAILS_ENDPOINT = `stripe/details`;
  try {
    let { data } = await api.get(`${STRIPE_DETAILS_ENDPOINT}`);

    dispatch({ type: GET_STRIPE_DETAILS_COMPLETE, payload: data });
  } catch (e) {

  }
}

export const getStripePlans = () => async dispatch => {
  const STRIPE_PLANS_ENDPOINT = `stripe/plans`;
  try {
    let { data } = await api.get(`${STRIPE_PLANS_ENDPOINT}`);

    dispatch({ type: GET_STRIPE_PLANS_COMPLETE, payload: data });
  } catch (e) {

  }
}

export const getFreeSubscription = () => async dispatch => {
  const GET_FREE_PREMIUM_ENDPOINT = `user/premium/free`;
  try {
    let { data } = await api.patch(`${GET_FREE_PREMIUM_ENDPOINT}`);
  } catch (e) {

  }
}

export const createSubscription = (source_id, card, email, plan_id, stripe_plans_dict) => async dispatch => {
  try {
    let { data } = await api.post("stripe/subscription", JSON.stringify({
      source_id: source_id,
      card: card,
      email: email,
      plan_id: plan_id,
      stripe_plan_id: stripe_plans_dict[plan_id].id
    }));
  } catch (e) {
    request_error(e);
  }
}

export const deleteSource = (source_id) => async dispatch => {
  try {
    let { data } = await api.delete("stripe/source", {
      data: {
        source_id: source_id
      }
    });
  } catch (e) {
    request_error(e);
  }
}

export const deleteSubscription = () => async dispatch => {
  try {
    await api.delete("stripe/subscription");
  } catch (e) {
    request_error(e);
  }
}
//
// export const emailChanged = (text) => {
//   return {
//     type: EMAIL_CHANGED,
//     payload: text
//   };
// };
